import { State } from "./store"
import { LoadingSpinner } from "./ui.slice"

export const getTransportOrderLoadingSpinnerState
    = (store: State): boolean | undefined => store.ui.loadingSpinner[LoadingSpinner.FetchTransportOrders]